import type React from 'react';

import { Box, Typography } from '@mui/material';

import { useStyles } from 'components/tournament/styles';

interface TabPanelProps {
  className?: string;
  index: any;
  value: any;
}

const TabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = ({ children, className, index, value }) => {
  const { classes } = useStyles();
  return (
    <Typography
      aria-labelledby={`tb-${value}`}
      className={className}
      component={'div'}
      hidden={value !== index}
      id={`tournament-tabpanel-${value}`}
      role={'tabpanel'}
    >
      {value === index && <Box className={classes.tabPanel}>{children}</Box>}
    </Typography>
  );
};

export default TabPanel;
